export default "__VITE_ASSET__4372fc79__"